<template>
  <div class="MakeItem">

    <div class="main">

      <div class="make" v-if="isMake" >
        <p class="make_titile">预约</p>
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="1">现在预约</van-radio>
          <van-radio name="2">以后预约</van-radio>
        </van-radio-group>
      </div>

      <div class="main_content">

        <div>
          <div class="title">
            <p>基本信息</p>
          </div>
          <div class="info_form">
            <van-form ref="info_form" :show-error="false" label-width="80" >
              <van-field
                  v-model="info_form.name"
                  name="name"
                  label="体检人姓名"
                  placeholder="请输入体检人姓名"
                  :rules="[{ required: true, message: '请填写体检人姓名' }]"
              >
                <template #right-icon>
                  <div class="icon">
                    <i class="iconfont icon-jiaren"></i>
                    <p>选择</p>
                  </div>
                </template>
              </van-field>

              <van-field
                  v-model="info_form.idCardNo"
                  name="idCardNo"
                  label="身份证号"
                  placeholder="请输入体检人身份证号"
                  :rules="[{ required: true, message: '请填写体检人身份证号' },{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '体检人身份证号不正确' }]"
              />

              <van-field name="radio" label="性别">
                <template #input>
                  <div style="width: 100%; display: flex; justify-content: flex-end;">
                    {{ info_form.gender }}
                  </div>
                </template>
              </van-field>

              <van-field
                  v-model="info_form.phoneNo"
                  name="phoneNo"
                  label="手机号"
                  placeholder="请输入体检人手机号"
                  :rules="[{ required: true, message: '请填写体检人手机号' },{ pattern: /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/, message: '体检人手机号不正确' }]"
              />

            </van-form>
          </div>
        </div>

        <div>
          <div class="title">
            <p>时间地点</p>
          </div>
          <div class="services">
            <van-collapse v-model="activeNames">
              <van-collapse-item :title="collapse_title" name="1">

                <van-form ref="physicalVO" @submit="onSubmit" :show-error="false" label-width="60" >

                  <van-field
                      class="grey_input"
                      readonly
                      clickable
                      name="appointmentDate"
                      :value="physicalVO.appointmentDate"
                      label="预约日期"
                      placeholder="请选择预约日期"
                      @click="showPickerDeta = true"
                      :rules="[{ required: true, message: '请选择预约日期' }]"
                  >
                    <template #right-icon>
                      <div>
                        <p class="iconfont icon-xuanzeriqi"></p>
                      </div>
                    </template>
                  </van-field>
                  <van-popup v-model="showPickerDeta" position="bottom">
                    <van-datetime-picker
                        type="date"
                        title="选择年月日"
                        :min-date="minDate"
                        @confirm="onConfirmDeta"
                        @cancel="showPickerDeta = false"
                    />
                  </van-popup>

                  <van-field
                      class="grey_input"
                      readonly
                      clickable
                      name="appointmentTime"
                      :value="physicalVO.appointmentTime"
                      label="预约时段"
                      placeholder="请选择预约时段"
                      :rules="[{ required: true, message: '请选择预约时段' }]"
                      @click="showPickerTime = true"
                  >
                    <template #right-icon>
                      <div>
                        <p class="iconfont icon-shangxiaxuanze" :class="( showPickerTime ? 'icon-shangxiaxuanze-zhuan' : '' )"></p>
                      </div>
                    </template>
                  </van-field>
                  <van-popup v-model="showPickerTime" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columnsTime"
                        @confirm="onConfirmTime"
                        @cancel="showPickerTime = false"
                    />
                  </van-popup>

                  <van-field
                      :class="( disabled ? '' : 'grey_input' )"
                      readonly
                      clickable
                      name="hospitalId"
                      :value="physicalVO.hospitalId"
                      label="预约地点"
                      placeholder="请选择预约地点"
                      :rules="[{ required: true, message: '请选择预约地点' }]"
                      :disabled="disabled"
                      @click="(disabled ? '' : showPickerHospita = true )"
                  >
                    <template #right-icon>
                      <div v-if="!disabled">
                        <p class="iconfont icon-shangxiaxuanze"
                           :class="( showPickerHospita ? 'icon-shangxiaxuanze-zhuan' : '' )" ></p>
                      </div>
                    </template>
                  </van-field>
                  <van-popup v-model="showPickerHospita" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columnsHospita"
                        @confirm="onConfirmHospita"
                        @cancel="showPickerHospita = false"
                    />
                  </van-popup>

                </van-form>

              </van-collapse-item>
            </van-collapse>
          </div>
        </div>

        <div>
          <div class="title">
            <p>{{ JSON.parse(this.$route.query.order).productName }}</p>
            <div class="title_right">
              <p>￥{{ JSON.parse(this.$route.query.order).price }}</p>
              <i class="iconfont icon-tiaozhuan"></i>
            </div>
          </div>
          <div class="be_careful">
            <h2 v-if="isExa">体检注意事项</h2>
            <p class="examination" v-if="isExa">
              体检是人们做好预防保健工作的一项重要举措。在进行体检时，应注意以下几项：<br/>
              1.体检前必须空腹，应在体检前一晚10:00过后禁食，可以饮水，但是不能喝牛奶、豆浆等含有糖分的饮料。检查当天需抽完血、做完腹部超音波检查后，方可进食。<br/>
              2.体检前3天不要大鱼大肉，忌酒，不要吃过于油腻的高蛋白、高脂肪的食物，也不要过于剧烈的活动，会导致体检的结果出现偏差。避免使用对肝肾功能有影响的药物。<br/>
              3.体检时要着穿脱方便的服装、鞋袜，最好不佩戴项链等，女同志的文胸不要带钢托，不要穿金属亮片的内衣。。<br/>
              4.女士生理期，不宜作妇科检查及尿检;做妇科检查前应排空膀胱;乳腺远红外线复查最好选择在生理期后一周内。未婚女士不宜做妇科检查,有特殊需求者要签署相关协议(告知书)方可进行相应检查。<br/>
              5.做膀胱、前列腺、子宫、附件B超时，需要憋排尿。<br/>
              6.为避免血压波动发生危险，高血压患者应在服完降压药后再来体检。糖尿病或其他慢性病患者，也应在采血后及时服药，不可因体检而干扰常规治疗。<br/>
            </p>
            <h2 v-if="isTeact">胃肠镜注意事项</h2>
            <p class="tract" v-if="isTeact">
              胃镜检注意事项：<br/>
              1.体检者应该查乙肝表面抗原、胸片、心电图等，如果有严重的心肺疾病，不建议做胃镜检查。<br/>
              2.胃镜需要空腹检查，检查前一天的饮食以清淡饮食为主，检查前半个小时左右尽量不要喝水。<br/>
              3.糖尿病患者可以带一些糖块类食物，防止出现低血糖。心脏病、高血压的患者，要在医生的指导下，停用抗凝药一段时间，让凝血功能恢复到大致正常，再做胃镜查。<br/>
              4.胃镜检查过程中要按医嘱进行吞咽动作，可以有效的缓解恶心干呕等反应。<br/>
              5.检查后，半小时内不要喝水和吃东西，避免引起呛咳。当天宜清淡饮食，忌辛辣，次日可以恢复正常的饮食，但还是尽量避免坚硬、刺激性食物。<br/>
              6.胃镜后尽量卧床休息两到三个小时， 24小时内不能做剧烈运动。<br/>
              肠镜检查注意事项:<br/>
              1.检查前3天，进食低脂少渣饮食（如稀饭、面条、蒸鸡蛋等）。避免食用水果、蔬菜、全谷类和肉类。<br/>
              2.检查前2天，不要吃深色食物，避免影响肠镜观察。<br/>
              3.肠镜检查前需要禁食8小时、禁饮6小时。因此，检查前1晚进食清流质饮食后，就不能吃任何东西了。<br/>
              4.检查前一晚进行肠道准备工作，按医嘱服用泻药，使排出的粪便为清亮水样、无明显粪渣的状态。<br/>
              5.高血压病人，需服用降压药使血压正常。服用抗凝药物者需要提前告知医生。<br/>
              6.检查时需要穿宽松的衣裤。<br/>
              7.女性在经期需要谨慎，告知医生，由医生决定是否进行肠镜。<br/>
              8.检查后，若无腹痛、腹胀，可进食易消化的食物。如腹痛、腹胀明显，持续不能缓解或进行性加重，请您立即告知医生。<br/>
              9.如做了病理学检查或手术，需要卧床休息，3天内避免剧烈运动，1周内避免负重。<br/>
            </p>
          </div>
        </div>

      </div>

    </div>

    <div class="footer">
      <p>¥ 666.00</p>
      <mu-button v-if="isMake" round color="primary">立即支付</mu-button>
      <mu-button @click="onSubmit" v-else round color="primary">立即预约</mu-button>
    </div>


    <van-popup class="success_popup" v-model="show" :close-on-click-overlay="false">

      <div class="popup">
        <h2>预约提交成功</h2>
        <p>
          客服人员会尽快和您联系<br/>
          确认最终体检时间<br/>
          请耐心等待<br/>
        </p>
        <mu-button color="primary" round @click="confirm" >返回首页</mu-button>
      </div>

    </van-popup>


  </div>
</template>

<script>
// 预约单品
export default {
  name: "MakeItem",
  data() {
    return{
      // 是否预约
      radio: "1",
      // 基本信息
      info_form: {
        name: null,
        idCardNo: null,
        gender: "--", // 性别
        phoneNo: "",
        orderNo: null
      },
      // 体检
      physicalVO: {
        appointmentDate: "", // 预约日期
        appointmentTime: "", // 预约时段
        hospitalId: "", // 医院id
      },
      // 胃肠道
      colonoscopyVO: {

      },
      activeNames: ["1"],
      showPickerDeta: false,
      showPickerTime: false,
      showPickerHospita: false,
      show: false,
      // 日期
      minDate: new Date(),
      // 时段
      columnsTime: [],
      // 医院
      columnsHospita: [],
      disabled: false,
      // 预约
      isMake: true,
      // 体检
      isExa: false,
      // 胃肠道
      isTeact: false,
      collapse_title: null,
    }
  },
  watch:{
    info_form: {
      handler(newVal) {
        if(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(newVal.idCardNo)) {
          if((newVal.idCardNo[newVal.idCardNo.length-2] % 2) == 0 ) {
            this.info_form.gender= "女";
          }else {
            this.info_form.gender= "男";
          }
        }else {
          this.info_form.gender= "--";
        }
      },
      deep: true
    }
  },
  created() {
    // 日期
    this.minDate=this.minDate.setDate(this.minDate.getDate()+1);
    this.minDate=new Date(this.minDate);

    this.$store.dispatch("setPhysical");
    this.$store.dispatch("setColonoscopy");
    this.$store.dispatch("setHospital");

    if(!JSON.parse(this.$route.query.isMake)) {
      this.isMake= JSON.parse(this.$route.query.isMake);
      this.info_form.orderNo= JSON.parse(this.$route.query.order).orderNo;
    }

    console.log(JSON.parse(this.$route.query.order));

    if(JSON.parse(this.$route.query.order).categoryName == 0) {
      document.title= "体检预约";
      this.collapse_title= "体检套餐";
      this.columnsTime= this.$store.state.physical;
      this.disabled= true;
      this.physicalVO.hospitalId= this.$store.state.hospital[0].text;
      this.isExa= true;
    }else if(JSON.parse(this.$route.query.order).categoryName == 1) {
      document.title= "胃肠道筛查预约";
      this.collapse_title= "胃肠道套餐";
      this.columnsTime= this.$store.state.colonoscopy;
      this.columnsHospita= this.$store.state.hospital;
      this.isTeact= true;
    }else if(JSON.parse(this.$route.query.order).categoryName == 2) {
      document.title= "整合式筛查预约";
      this.isExa= true;
      this.isTeact= true;
    }else if(JSON.parse(this.$route.query.order).categoryName == 3) {
      document.title= "锦医未预约";
    }

  },
  mounted() {

  },
  methods: {
    // 提交
    onSubmit() {
      this.$refs.info_form.validate()
        .then(() => {
          this.$refs.physicalVO.validate()
            .then(() => {

              if(JSON.parse(this.$route.query.order).categoryName == 0) {
                // 体检
                this.info_form["physicalVO"]= {};
                this.info_form.physicalVO["appointmentDate"]= this.physicalVO.appointmentDate;
                this.info_form.physicalVO["appointmentTime"]= this.$store.state.physical.filter((item)=> { return item.text == this.physicalVO.appointmentTime })[0].value;
                this.info_form.physicalVO["hospitalId"]= this.$store.state.hospital.filter((item)=> { return item.text == this.physicalVO.hospitalId })[0].value;
              }else if(JSON.parse(this.$route.query.order).categoryName == 1) {
                this.info_form["colonoscopyVO"]= {};
                this.info_form.colonoscopyVO["appointmentDate"]= this.physicalVO.appointmentDate;
                this.info_form.colonoscopyVO["appointmentTime"]= this.$store.state.colonoscopy.filter((item)=> { return item.text == this.physicalVO.appointmentTime })[0].value;
                this.info_form.colonoscopyVO["hospitalId"]= this.$store.state.hospital.filter((item)=> { return item.text == this.physicalVO.hospitalId })[0].value;
                // 胃肠道
              }else if(JSON.parse(this.$route.query.order).categoryName == 2) {
                // 整合式
              }else if(JSON.parse(this.$route.query.order).categoryName == 3) {
                // 锦医未
              }

              console.log(this.info_form);

              this.$post("appointment",this.info_form)
                .then(res => {
                  if(res) {
                    console.log(res)
                    this.show= true;
                  }
                })


            })
        })
    },
    confirm() {
      this.$router.replace({
        path: "/index"
      })
    },
    // 日期
    onConfirmDeta(value) {
      this.physicalVO.appointmentDate= this.formatDate(value);
      this.showPickerDeta= false;
    },
    // 时段
    onConfirmTime(value) {
      this.physicalVO.appointmentTime= value.text;
      this.showPickerTime= false;
    },
    // 医院
    onConfirmHospita(value) {
      this.physicalVO.hospitalId= value.text;
      this.showPickerHospita= false;
    }
  }
}
</script>

<style lang="less" scoped>
   @import "../../../style/Make/MakeItem";
</style>
